import { render, staticRenderFns } from "./RiwayatPenyakit.vue?vue&type=template&id=306fd68b&"
import script from "./RiwayatPenyakit.vue?vue&type=script&lang=ts&"
export * from "./RiwayatPenyakit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VTextarea})
